let initialHeaderHeight = 0;
const announcementBar = document.querySelector(".announcement-bar-section");
function addStickyClass() {
  const currentHeaderHeight = document.querySelector("header").offsetHeight + announcementBar.offsetHeight;
  const mainContent = document.querySelector(".js-collection-links");
  if (initialHeaderHeight != currentHeaderHeight) {
    mainContent.style.top = currentHeaderHeight + "px";
    initialHeaderHeight = currentHeaderHeight;
  }
}
addStickyClass();
window.addEventListener("resize", addStickyClass);
const wrapperCollectionsTabs = document.querySelector(".js-scroll-collections-tabs");
const activeTab = document.querySelector(".js-collection-tab-active");
const wrapperPadding = +window.getComputedStyle(wrapperCollectionsTabs, null).getPropertyValue("padding-left").replace("px", "");
if (wrapperCollectionsTabs && activeTab) {
  wrapperCollectionsTabs.scrollTo({
    left: activeTab.offsetLeft - wrapperPadding,
    behavior: "smooth"
  });
}
